module.exports = __webpack_public_path__ + "img/other-maps.2fdc9c5d.svg";